import { motion } from "motion/react";
import { Dialog as D } from "radix-ui";
import { twMerge } from "tailwind-merge";

export const Dialog = ({ children, ...props }: D.DialogProps) => {
  return <D.Root {...props}>{children}</D.Root>;
};

Dialog.Trigger = D.Trigger;
Dialog.Close = D.Close;
Dialog.Title = D.Title;

const Content = ({
  className,
  style,
  children,
  ...props
}: D.DialogContentProps) => {
  return (
    <D.Portal>
      <D.Overlay asChild>
        <motion.div
          animate={{ opacity: 1 }}
          className="fixed inset-0 z-0 bg-[#141414]/70"
          initial={{ opacity: 0 }}
        />
      </D.Overlay>
      <D.Content asChild {...props}>
        <motion.div
          animate={{ opacity: 1 }}
          className={twMerge(
            "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
            "focus:outline-hidden",
            "z-10 flex flex-col rounded-xl bg-white shadow-xl",
            "transition-opacity",
            className
          )}
          initial={{ opacity: 0 }}
          style={style}
        >
          {children}
        </motion.div>
      </D.Content>
    </D.Portal>
  );
};

Dialog.Content = Content;
